import { render, staticRenderFns } from "./SOV4Detailed.vue?vue&type=template&id=845d4b3e&scoped=true"
import script from "./SOV4Detailed.vue?vue&type=script&lang=js"
export * from "./SOV4Detailed.vue?vue&type=script&lang=js"
import style0 from "./SOV4Detailed.vue?vue&type=style&index=0&id=845d4b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845d4b3e",
  null
  
)

export default component.exports